// Central source of truth for event types displayed across the site.
// `active: true` -> tile links to the live enquiry form
// `active: false` -> tile links to the Coming Soon page

export const EVENTS = [
  {
    slug: "hotel-airbnb",
    title: "Hotel & Airbnb Setups",
    short: "Hotel / Airbnb",
    blurb:
      "From romantic surprises to girls weekends away, we create beautifully styled stays to remember.",
    image: "/sunstate/gallery/pink-hotel-wide.webp",
    active: true,
    href: "/sunstate/enquiry.html",
  },
  {
    slug: "picnics",
    title: "Picnics",
    short: "Picnics",
    blurb:
      "Beautifully styled boutique picnics for proposals, dates, birthdays and gatherings by the beach.",
    image: "/sunstate/gallery/picnic-1.jpg",
    active: true,
    href: "/sunstate/picnic-enquiry.html",
  },
  {
    slug: "home-celebrations",
    title: "Home Celebrations",
    short: "Home",
    blurb:
      "Baby showers, engagement parties, milestone birthdays and intimate gatherings styled at home.",
    image: "/sunstate/gallery/home-halloween.jpg",
    active: false,
  },
  {
    slug: "corporate",
    title: "Corporate Events",
    short: "Corporate",
    blurb:
      "Launches, brand activations, dinners and conferences — refined styling and seamless coordination.",
    image:
      "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1200&q=80&auto=format&fit=crop",
    active: false,
    isPlaceholder: true,
  },
  {
    slug: "proposals",
    title: "Proposals",
    short: "Proposals",
    blurb:
      "Once-in-a-lifetime proposal setups — beach, rooftop, garden or surprise location.",
    image:
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80&auto=format&fit=crop",
    active: false,
    isPlaceholder: true,
  },
  {
    slug: "venue-celebrations",
    title: "Venue Celebrations",
    short: "Venue",
    blurb:
      "Baby showers, engagement parties, birthdays and celebrations styled at private venues.",
    image: "/sunstate/gallery/venue-21st-full-backdrop.webp",
    active: false,
  },
];

export const getEventBySlug = (slug) =>
  EVENTS.find((e) => e.slug === slug) || null;
